export default __webpack_public_path__ + "static/media/FUJIFILM_Slogan.527a7a93.png";